import React from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap';
import Header from "./Header"
import related1 from "./images/related1.jpg"
import related2 from "./images/related2.jpg"
import related3 from "./images/related3.jpg"


function Related(){
    return(
        <div>
            <br/>
            <Container>
            <Row>
                    <Col xs="12">
                    <h2 className="display-3 text-left">Related links</h2>
                    <br/>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" md="4">
                    <a className="relatedlinks" href="https://www.aljazeera.com/topics/country/yemen.html" target="_blank"><h3>Yemen News</h3></a>
                        <a className="relatedlinks" href="https://www.aljazeera.com/topics/country/yemen.html" target="_blank"><img className="img-fluid" src={related3}/></a>
                    </Col>
                    <Col xs="12" md="4">
                    <a className="relatedlinks" href="https://www.aljazeera.com/news/2016/06/key-facts-war-yemen-160607112342462.html" target="_blank"><h3>Yemen: Key facts</h3></a>
                        <a className="relatedlinks" href="https://www.aljazeera.com/news/2016/06/key-facts-war-yemen-160607112342462.html" target="_blank"><img className="img-fluid" src={related1}/></a>
                    </Col>
                    <Col xs="12" md="4">
                    <a className="relatedlinks" href="https://www.facebook.com/watch/?v=2892687260955864" target="_blank"><h3>The human cost of war</h3></a>
                        <a className="relatedlinks" href="https://www.facebook.com/watch/?v=2892687260955864" target="_blank"><img className="img-fluid" src={related2}/></a>
                    </Col>
                </Row>
            </Container>
            <br/>
        </div>
    )
}
export default Related